//
// Writable application context
//
import { StripeApiClient } from "../client";
import { HttpApiError, HttpApiMiddleware } from "@effect/platform";
import { Context, Schema } from "effect";
export class StripeController extends Context.Tag("@open-revenue/stripe/storage/StripeStorageController")() {
}
export class StripeControllerMiddleware extends HttpApiMiddleware.Tag()("@open-revenue/stripe/StripeController", {
    // Define the error schema for unauthorized access
    failure: HttpApiError.NotFound,
    // Specify the resource this middleware will provide
    provides: StripeController
}) {
}
export class StripeApiNoConfiguration extends Schema.Class("open-revenue-stripe-StripeApiNoConfiguration")({
    object: Schema.Literal("error"),
    code: Schema.Literal("no_configuration"),
    message: Schema.Literal("No configuration found for this application")
}) {
    static Default = {
        object: "error",
        code: "no_configuration",
        message: "No configuration found for this application"
    };
}
export class StripeApiMiddleware extends HttpApiMiddleware.Tag()("@open-revenue/stripe/StripeApi", {
    failure: Schema.Union(HttpApiError.NotFound, StripeApiNoConfiguration),
    provides: StripeApiClient
}) {
}
